class Utils {

    static generateUid() {

        let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';

        for ( var i = 0; i < 10; i++ ) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }

        return result;
    }

    static relativeTime(datetime) {

        let msPerSecond = 1000;
        let msPerMinute = 60 * msPerSecond;
        let msPerHour = msPerMinute * 60;
        let msPerDay = msPerHour * 24;
        let msPerMonth = msPerDay * 30;
        let msPerYear = msPerDay * 365;

        let elapsed = new Date() - datetime;

        if ( elapsed < msPerSecond ) {
            return 'een paar seconden geleden'
        }        
        else if (elapsed < msPerMinute) {
            let seconds = Math.round(elapsed/msPerSecond);

             return seconds !== 1 ?
                seconds + ' seconden geleden':
                seconds + ' seconde geleden';
        }

        else if (elapsed < msPerHour) {
            let minutes = Math.round(elapsed/msPerMinute);

            return minutes !== 1 ?
               minutes + ' minuten geleden':
               minutes + ' minuut geleden';
        }
        else if (elapsed < msPerDay ) {
            let hours = Math.round(elapsed/msPerHour);

             return hours !== 1 ?
                hours + ' uren geleden':
                hours + ' uur geleden';
        }
        else if (elapsed < msPerMonth) {
            let days = Math.round(elapsed/msPerDay);

            return days !== 1 ?
               days + ' dagen geleden':
               days + ' dag geleden';
        }
        else if (elapsed < msPerYear) {
            let months = Math.round(elapsed/msPerMonth);

            return months !== 1 ?
               months + ' maanden geleden':
               months + ' maand geleden';
        }
        else {
            let years = Math.round(elapsed/msPerYear);

            return years !== 1 ?
               years + ' jaren geleden':
               years + ' jaar geleden';
        }
    }
}

export default Utils;
